var exports = {
  "k": "x93eb46d8--ae768b--container",
};

module.exports = exports;
